// import React, { useEffect, useState } from "react";
// import { FaFileImage, FaFileVideo, FaFilePdf, FaFileAudio } from "react-icons/fa"; // For icons
// import TrainingCardComponent from "./TrainingCard";


// interface CardData {
//   id: number;
//   title: string;
//   count: number;
//   fileType: string;
// }

// const NewTrainingCard = () => {
//   const [cardData, setCardData] = useState<CardData[]>([]); // Set state type to CardData array

//   useEffect(() => {
//     // Fetch data from API
//     fetch("/api/training-data") // Replace with your API endpoint
//       .then(response => response.json())
//       .then(data => {
//         setCardData(data); // Set the fetched data
//       })
//       .catch(error => console.error("Error fetching data:", error));
//   }, []);

//   const handleDownload = (fileId: number) => {
//     // Implement the file download logic here
//     console.log("Downloading file with ID:", fileId);
//   };

//   const getIcon = (fileType: string) => {
//     switch (fileType) {
//       case "image":
//         return <FaFileImage />;
//       case "video":
//         return <FaFileVideo />;
//       case "pdf":
//         return <FaFilePdf />;
//       case "audio":
//         return <FaFileAudio />;
//       default:
//         return <FaFileImage />;
//     }
//   };

//   return (
//     <div className="training-cards-grid">
//       {cardData.map((item) => (
//         <TrainingCardComponent
//           key={item.id}
//           icon={getIcon(item.fileType)} // Dynamically set icon based on fileType
//           title={item.title}
//           count={item.count}
//           label="Reports"
//           onDownload={() => handleDownload(item.id)} // Add unique file id
//         />
//       ))}
//     </div>
//   );
// };

// export default NewTrainingCard;



import React, { useState } from "react";
import { FaFileImage, FaFileVideo, FaFilePdf, FaFileAudio } from "react-icons/fa"; // For icons
import TrainingCardComponent from "./TrainingCard";

// Define the type for card data
interface CardData {
  id: number;
  title: string;
  count: number;
  fileType: string;
}

const NewTrainingCard = () => {
  // Static data
  const [cardData] = useState<CardData[]>([
    { id: 1, title: "Images", count: 10, fileType: "image" },
    { id: 2, title: "Videos", count: 5, fileType: "video" },
    { id: 3, title: "PDF", count: 3, fileType: "pdf" },
    { id: 4, title: "Audio", count: 8, fileType: "audio" }
  ]);

  const handleDownload = (fileId: number) => {
    // Implement the file download logic here
    console.log("Downloading file with ID:", fileId);
  };

  const getIcon = (fileType: string) => {
    switch (fileType) {
      case "image":
        return <FaFileImage />;
      case "video":
        return <FaFileVideo />;
      case "pdf":
        return <FaFilePdf />;
      case "audio":
        return <FaFileAudio />;
      default:
        return <FaFileImage />;
    }
  };

  return (
    <div className="training-cards-grid">
      {cardData.map((item) => (
        <TrainingCardComponent
          key={item.id}
          icon={getIcon(item.fileType)} // Dynamically set icon based on fileType
          title={item.title}
          count={item.count}
          label="Reports"
          onDownload={() => handleDownload(item.id)} // Add unique file id
        />
      ))}
    </div>
  );
};

export default NewTrainingCard;
